import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

export function LcswPermissionSkeleton() {
  return (
    <DashboardCard2 title={<Skeleton width={160} />}>
      <div className="tw:flex tw:items-start tw:gap-4 tw:leading-none">
        <Skeleton borderRadius={12} height={24} width={44} />
        <div className="tw:flex tw:flex-col tw:gap-2">
          <Skeleton height={16} width={140} />
          <Skeleton height={12} width={280} />
        </div>
      </div>
    </DashboardCard2>
  );
}
